import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import clsx from 'clsx';
import { RadioContext } from '../radio-primitive/radio-context.js';
import { Root as Root$1 } from '../radio-primitive/radio-group.js';
import { Option as Option$1 } from '../radio-primitive/radio-option.js';
import { resolveStyleValue } from '../utils/style-value.js';
import { srOnly } from '../styles/composables.css.js';
import { hiddenInput, optionRoot } from './radio-like-primitive.css.js';

/**
 * Root component for anything that involves choosing between independent states.
 * @see https://fpl.figma.design/components/primitives/radio-like/
 */
const Root = forwardRef(({ legend, ...props }, ref) => (jsxs(Root$1, { ref: ref, ...props, children: [legend, jsx("div", { "data-radio-options-root": true, children: props.children })] })));
Root.displayName = 'RadioLikePrimitive.Root';
/**
 * An option for `RadioLikePrimitive.Root`.
 * @see https://fpl.figma.design/components/primitives/radio-like/
 */
const Option = forwardRef(({ 'aria-label': ariaLabel, value, children, className, styles: stylesIn, ...props }, ref) => {
    const { name } = useContext(RadioContext);
    const id = `${name}-${value}`;
    const inputStyles = resolveStyleValue(stylesIn?.input);
    return (jsxs("div", { "data-fpl-component": "primitive", className: clsx(optionRoot, className), children: [jsx(Option$1, { "data-fpl-component": undefined, ...props, ref: ref, className: clsx(inputStyles.className, hiddenInput), style: inputStyles.style, id: id, value: value, "data-tooltip": props?.['data-tooltip'] ?? ariaLabel, "data-tooltip-type": props?.['data-tooltip-type'] ?? 'text' }), children, jsx("label", { className: srOnly, htmlFor: id, children: ariaLabel })] }));
});
Option.displayName = 'RadioLikePrimitive.Option';
/**
 * An option for `RadioLikePrimitive.Root`. The user _must_ provide a label for this option.
 * The Label should have a `htmlFor` attribute that matches the `id` of this option. The `id` can
 * be created via the `useId` hook.
 *
 * @see https://fpl.figma.design/components/primitives/radio-like/
 */
const ManuallyLabeledOption = forwardRef(({ children, className, ...props }, ref) => {
    return (jsxs("div", { "data-fpl-component": "primitive", className: clsx(optionRoot, className), children: [jsx(Option$1, { "data-fpl-component": undefined, className: hiddenInput, ref: ref, ...props }), children] }));
});
ManuallyLabeledOption.displayName = 'RadioLikePrimitive.ManuallyLabeledOption';

export { ManuallyLabeledOption, Option, Root };
//# sourceMappingURL=radio-like-primitive.js.map
